// extracted by mini-css-extract-plugin
export default {"container":"category_container__2rQKh"};